import { Controller } from '@hotwired/stimulus';

// Auto-shows a modal overlay on connect and dismisses on button click or Escape.
// Used for pilot countdown and grace period modals.
//
// Usage:
//   <div data-controller="pilot-modal" class="hidden">
//     <button data-action="click->pilot-modal#dismiss">J'ai compris</button>
//   </div>
export default class extends Controller {
  connect() {
    this.previousFocus = document.activeElement;
    this.boundHandleKeydown = this.handleKeydown.bind(this);
    this.element.addEventListener('keydown', this.boundHandleKeydown);

    // Small delay so the page renders before showing the modal
    requestAnimationFrame(() => {
      this.element.classList.remove('hidden');
      // Move focus to the first button for accessibility
      const button = this.element.querySelector('button');
      if (button) button.focus();
    });
  }

  disconnect() {
    this.element.removeEventListener('keydown', this.boundHandleKeydown);
    this.previousFocus = null;
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.dismiss();
      return;
    }

    if (event.key === 'Tab') {
      const focusable = this.element.querySelectorAll(
        'button, a[href], input, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey) {
        if (document.activeElement === first) {
          event.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  }

  dismiss() {
    this.element.classList.add('hidden');
    if (this.previousFocus && typeof this.previousFocus.focus === 'function') {
      this.previousFocus.focus();
    }
  }
}
